import { RemoteProfile } from '../../../data/usecases/profiles/remote-profile'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const apiToFormik = (response: any) => (
  {
    name: response.name,
    description: response.description,
    permissions: response.permissions.map((permission: any) => JSON.stringify(permission)),
  }
)

export const makeProfile = (stablismentId: number) => (
  new RemoteProfile(`/stablishments/${stablismentId}/profiles`, makeAxiosHttpClient())
)
